// extracted by mini-css-extract-plugin
export default {"bigWinSection":"Fc8AiJqaWT68fuwMU5O5","bigWinCard":"k6jQ37QqyNthmh79YDFD","infoHref":"ZGDwNnpXNRUKhBaSGShb","bigWinCardContent":"Vwy1v06Idz9MrZFGII8F","bigWinCardText":"wYI2RCbD55X_Rdvozmv_"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"bigWinSection\":\"Fc8AiJqaWT68fuwMU5O5\",\"bigWinCard\":\"k6jQ37QqyNthmh79YDFD\",\"infoHref\":\"ZGDwNnpXNRUKhBaSGShb\",\"bigWinCardContent\":\"Vwy1v06Idz9MrZFGII8F\",\"bigWinCardText\":\"wYI2RCbD55X_Rdvozmv_\"}";
        // 1755964983635
        var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  